var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 169.576,
    height: 128.193,
    viewBox: "0 0 169.576 128.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10598",
    "data-name": "Rectangle 10598",
    width: 169.576,
    height: 128.193,
    transform: "translate(0 0)",
    fill: "#5e2b97",
    stroke: "#707070",
    strokeWidth: 0.25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loginLogo",
    transform: "translate(0 118.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14562",
    "data-name": "Group 14562",
    transform: "translate(0 -118.134)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M144.7,41.9,104,2.659a9.742,9.742,0,0,0-13.376,0L63.736,28.594,92.394,56.248a10.691,10.691,0,0,1,0,15.439,11.413,11.413,0,0,1-7.524,3.179l.205.2a10.614,10.614,0,0,1-.016,15.455,11.626,11.626,0,0,1-14.983.867,10.615,10.615,0,0,1-3.3,7.362,11.609,11.609,0,0,1-16.011-.015l-2.65-2.555a10.7,10.7,0,0,1-3.3,7.271,11.264,11.264,0,0,1-6.532,3.1l19.685,18.984a9.764,9.764,0,0,0,13.393,0L144.7,54.818a8.915,8.915,0,0,0,0-12.914m-18.769.974-.08.091a2.942,2.942,0,0,1-4.006,0L102.915,24.7a2.652,2.652,0,0,1,0-3.848l.08-.091a2.912,2.912,0,0,1,4.006,0L125.93,39.014a2.67,2.67,0,0,1,0,3.864",
    transform: "translate(22.107 0)",
    fill: "#5e2b97",
    stroke: "#707070",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M63.807,91.008,43.05,71.02l3.675-3.544L76,95.723a7.084,7.084,0,0,0,9.764,0,6.516,6.516,0,0,0,0-9.416L56.473,58.076l3.659-3.544L94.3,87.494a7.084,7.084,0,0,0,9.764,0,6.481,6.481,0,0,0,0-9.431L69.9,45.131l3.659-3.544,28.076,27.076a7.064,7.064,0,0,0,9.748,0,6.494,6.494,0,0,0,.032-9.385l-.032-.03L82.7,31.593,65.022,14.541,59.959,9.673a35.235,35.235,0,0,0-48.14-.289l-.142.137-1.562,1.491a32.431,32.431,0,0,0,0,47.064l43.913,42.363a.783.783,0,0,0,.126.106,1.077,1.077,0,0,0,.205.167,7.078,7.078,0,0,0,9.448-.274,6.534,6.534,0,0,0,0-9.431",
    transform: "translate(0 0.013)",
    fill: "#5e2b97",
    stroke: "#707070",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/loginLogo.029bea1c334482dfa35aac4ea65d7da7.svg";
export { ForwardRef as ReactComponent };